"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailDecoder = void 0;
const simple_errors_1 = require("@simonbackx/simple-errors");
class EmailDecoderStatic {
    decode(data) {
        const str = data.string;
        const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
        if (!regex.test(str)) {
            throw new simple_errors_1.SimpleError({
                code: "invalid_field",
                message: "Received an invalid email address",
                human: "Dit e-mailadres is ongeldig, kijk je het na?",
                field: data.currentField,
            });
        }
        return str;
    }
}
// We export an instance to prevent creating a new instance every time we need to decode a number
exports.EmailDecoder = new EmailDecoderStatic();
//# sourceMappingURL=EmailDecoder.js.map